import client from './apiErpConnector';

// 500 si size > 4, Probleme de timemout entre l'erp et l'api java
async function getUser(userId) {
  return client().get(`/users/${userId}`);
}

async function addUser(userParams) {
  return client().post('/users', userParams);
}

async function editUserPassword(userId, newPassword) {
  return client().put(`/users/${userId}/secret`, newPassword);
}

export default {
  getUser,
  addUser,
  editUserPassword,
};
